module.exports = __webpack_public_path__ + "static/media/pay-more-dollar.963093dc.png";